import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AskExpertProfessionalRoutingModule} from './ask-expert-professional-routing.module';
import {AskExpertProfessionalComponent} from './ask-expert-professional.component';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {CoreSidebarModule} from '../../../@core/components';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [AskExpertProfessionalComponent],
    imports: [
        CommonModule,
        CoreCommonModule,
        CardSnippetModule,
        CoreSidebarModule,
        AskExpertProfessionalRoutingModule,
        NgbPaginationModule
    ],
    exports: [AskExpertProfessionalComponent]
})

export class AskExpertProfessionalModule {
}
